import {Component} from '@angular/core';

import {ValueView} from '../../value-view';

@Component({
  selector: 'ax-text-value-view',
  templateUrl: './text-value-view.component.html',
})
export class TextValueViewComponent extends ValueView {}
